<div class="progress-loader" *ngIf="loading">
    <div class="wrapper">
      <div class="ball-scale-multiple">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
</div>